import React from "react";
import { Phone, Mail, Instagram, Facebook, MapPin } from "lucide-react";

const TIKTOK_PATH =
  "M232 96a64 64 0 0 1-64-64V8h-40v160a40 40 0 1 1-40-40v-40a80 80 0 1 0 80 80V104a103.6 103.6 0 0 0 64 24z";

export default function Footer() {
  return (
    <footer id="contact" data-testid="site-footer" className="relative bg-[#050505] border-t border-white/10 px-6 md:px-12 lg:px-20 pt-24 pb-10">
      <div className="max-w-7xl mx-auto">
        <div className="grid md:grid-cols-12 gap-12 pb-16">
          <div className="md:col-span-5">
            <div className="font-display text-6xl md:text-7xl font-light tracking-[0.12em]">STAC</div>
            <p className="overline mt-3">St Auto Care</p>
            <p className="mt-8 text-white/65 max-w-md leading-relaxed">
              Premium mobile car detailing. West Midlands based. Nationwide coverage across the UK.
              We bring the kit — you keep the keys.
            </p>
          </div>

          <div className="md:col-span-3">
            <div className="overline mb-5">Contact</div>
            <ul className="space-y-3">
              <li>
                <a
                  href="tel:07305424825"
                  data-testid="footer-phone"
                  className="group flex items-center gap-3 text-sm text-white/80 hover:text-white"
                >
                  <Phone size={14} className="text-white/40 group-hover:text-white/70" /> 07305 424 825
                </a>
              </li>
              <li>
                <a
                  href="mailto:stautocarecontact@gmail.com"
                  data-testid="footer-email"
                  className="group flex items-start gap-3 text-sm text-white/80 hover:text-white break-all"
                >
                  <Mail size={14} className="text-white/40 mt-1 group-hover:text-white/70 flex-shrink-0" /> stautocarecontact@gmail.com
                </a>
              </li>
              <li className="flex items-center gap-3 text-sm text-white/80">
                <MapPin size={14} className="text-white/40" /> West Midlands · UK
              </li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <div className="overline mb-5">Follow</div>
            <div className="flex items-center gap-3">
              <a
                href="https://instagram.com/st_auto_care"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-instagram"
                aria-label="Instagram"
                className="w-11 h-11 inline-flex items-center justify-center border border-white/15 hover:border-white/60 transition-colors"
              >
                <Instagram size={16} />
              </a>
              <a
                href="https://tiktok.com/@st_auto_care"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-tiktok"
                aria-label="TikTok"
                className="w-11 h-11 inline-flex items-center justify-center border border-white/15 hover:border-white/60 transition-colors"
              >
                <svg width="16" height="16" viewBox="0 0 256 256" fill="currentColor"><path d={TIKTOK_PATH} /></svg>
              </a>
              <a
                href="https://facebook.com/STAC"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-facebook"
                aria-label="Facebook"
                className="w-11 h-11 inline-flex items-center justify-center border border-white/15 hover:border-white/60 transition-colors"
              >
                <Facebook size={16} />
              </a>
            </div>
            <p className="mt-6 text-xs text-white/45">@st_auto_care · STAC on Facebook</p>
          </div>
        </div>

        <div className="hairline" />

        <div className="pt-8 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <p className="text-xs text-white/40 tracking-wider">
            © {new Date().getFullYear()} St Auto Care · All rights reserved.
          </p>
          <p className="text-xs text-white/40 tracking-[0.2em] uppercase">
            Designed for the detail-obsessed.
          </p>
        </div>
      </div>
    </footer>
  );
}
